import config from "@/lib/config";
import IdcAPI from "./idcapi";

class Idc extends IdcAPI {
  async tokenEndPoint(code, redirectUri) {
    const body = new URLSearchParams();
    body.append("grant_type", "authorization_code");
    body.append("code", code);
    body.append("redirect_uri", redirectUri);
    body.append("client_id", config.idc.clientId);
    return await this.post("/idcs/sso/TokenEndpoint", {
      body,
    });
  }

  async userInfoEndPoint() {
    const result = await this.post("/idcs/sso/UserInfoEndpoint/");
    return result;
  }

  async tokenVerifyEndPoint() {
    const result = await this.post("/idcs/sso/TokenVerifyEndpoint/");
    return result;
  }
}
export default Idc;
